import ListItemPrice from 'LuxKit/List/ListItemPrice'
import useLuxPlusPrimaryCashPrice from 'luxPlus/hooks/useLuxPlusPrimaryCashPrice'

interface Props {
  price: number
  memberPrice: number
}

/** Match the existing multi-room footer's primary member/non-member cash display mode. */
function PackageSelectionQuantityPrice({ price, memberPrice }: Props) {
  const primaryPrice = useLuxPlusPrimaryCashPrice({ price, memberPrice })
  return <ListItemPrice price={primaryPrice} size="medium" />
}

export default PackageSelectionQuantityPrice
